module.exports = __webpack_public_path__ + "img/DSC00290.1c9f4816.JPG";